jQuery(document).foundation();

jQuery(window).load(function() {
	jQuery(".active > a").trigger('click');
});